import React from 'react';
import { Mail, Linkedin, MapPin } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { companyInfo } from '../mock';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            Get in touch to discuss your international expansion goals
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Let's Start the Conversation
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Whether you're exploring new markets or ready to launch your international expansion, we're here to help guide your journey.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {/* Address */}
            <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-lg group">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-900 transition-colors duration-300">
                  <MapPin className="text-blue-900 group-hover:text-white transition-colors duration-300" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Our Company Address</h3>
                <p className="text-gray-600 leading-relaxed">
                  {companyInfo.address.line1}<br />
                  {companyInfo.address.line2}<br />
                  {companyInfo.address.country}
                </p>
              </CardContent>
            </Card>

            {/* LinkedIn */}
            <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-lg group">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-900 transition-colors duration-300">
                  <Linkedin className="text-blue-900 group-hover:text-white transition-colors duration-300" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Connect on LinkedIn</h3>
                <a 
                  href={companyInfo.linkedin} 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-blue-900 transition-colors text-lg break-all"
                >
                  linkedin.com/company/regenr8-international
                </a>
              </CardContent>
            </Card>

            {/* Email */}
            <Card className="border-2 hover:border-blue-900 transition-all duration-300 hover:shadow-lg group">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-900 transition-colors duration-300">
                  <Mail className="text-blue-900 group-hover:text-white transition-colors duration-300" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Email Us</h3>
                <a href={`mailto:${companyInfo.email}`} className="text-gray-600 hover:text-blue-900 transition-colors text-lg break-all">
                  {companyInfo.email}
                </a>
              </CardContent>
            </Card>
          </div>

          {/* Additional Information */}
          <Card className="border-2 bg-blue-50">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">Regenr8 International FZ LLC</h3>
              <p className="text-gray-700 text-center leading-relaxed">
                Your trusted partner for international expansion. We look forward to learning about your business goals and exploring how we can support your global growth journey.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Business Hours Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Business Hours</h2>
          <p className="text-lg text-gray-600 mb-8">
            We operate across multiple time zones to serve our international clients
          </p>
          <div className="inline-block bg-gray-50 rounded-lg p-8 border-2 border-gray-200">
            <p className="text-gray-700 text-lg mb-2">
              <span className="font-semibold">Monday - Friday:</span> 9:00 AM - 6:00 PM (GST)
            </p>
            <p className="text-gray-700 text-lg">
              <span className="font-semibold">Saturday - Sunday:</span> By Appointment
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
